export default __webpack_public_path__ + "static/media/no-image.0809ca33.png";